import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { DuplicateListingController } from 'api';
import { DuplicateListingsForAgentType } from 'api/DuplicateListingController';
import { Button, Icon, ListingImage } from 'components';
import ListingInfo from '../../../../../components/UniversalSearch/components/ListingInfo';

import TaskLayout from './TaskLayout';

type DuplicatesItemProps = {
  duplicate: DuplicateListingsForAgentType['data'][0];
  index: number;
  fetchDuplicates: () => Promise<void>;
};

const DuplicatesItem: React.FC<DuplicatesItemProps> = ({
  duplicate,
  index,
  fetchDuplicates,
}) => {
  const { to, from } = duplicate;
  const thumbnailSize = 75;
  const title = index === 0 ? 'Duplicates' : null;

  const dismiss = async (id: string) => {
    await DuplicateListingController.dismiss(id);
    fetchDuplicates();
  };

  return (
    <TaskLayout
      title={title}
      content={
        <>
          <StyledListingContainer>
            <StyledListingImageContainer>
              <ListingImage imageSrc={from.thumbnail} size={thumbnailSize} />
            </StyledListingImageContainer>
            <StyledFromListingContainer>
              <ListingInfo
                line1={from.line1}
                line2={from.line2}
                province={from.province}
                city={from.city}
                availability={from.availability}
                price={from.list_price}
                status={{ type: from.status, mlsNumbers: from.mls_numbers }}
                dom={from.dom}
              />
            </StyledFromListingContainer>
          </StyledListingContainer>
          <StyledListingContainer>
            <StyledListingImageContainer>
              <ListingImage imageSrc={to.thumbnail} size={thumbnailSize} />
            </StyledListingImageContainer>
            <div>
              <ListingInfo
                line1={to.line1}
                line2={to.line2}
                province={to.province}
                city={to.city}
                availability={to.availability}
                price={to.list_price}
                status={{ type: to.status, mlsNumbers: to.mls_numbers }}
                dom={to.dom}
              />
            </div>
          </StyledListingContainer>
        </>
      }
      buttons={
        <StyledButtonContainer>
          <StyledButton
            onClick={() => dismiss(duplicate.id)}
            data-cy="dismiss-duplicate-button"
            size="small"
            icon={
              <Icon
                type="antdCloseOutlined"
                width={14}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Dismiss
          </StyledButton>
          <Link
            to={`/listing/merge?from=${from.id}&to=${to.id}`}
            data-cy="review-duplicate-link"
          >
            <StyledButton
              size="small"
              icon={
                <Icon
                  type="antdFolderViewOutlined"
                  width={14}
                  offset={[0, -2]}
                  color="gray8"
                />
              }
            >
              Review
            </StyledButton>
          </Link>
        </StyledButtonContainer>
      }
      dataCy="feedback-requested-item"
    />
  );
};

export default DuplicatesItem;

const StyledListingContainer = styled.div`
  display: flex;
`;

const StyledListingImageContainer = styled.div`
  margin-right: 16px;
`;

const StyledFromListingContainer = styled.div`
  margin-bottom: 16px;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledButton = styled(Button)`
  padding-left: 20px;
  padding-right 20px;
`;
